export default (obj, fileName) => {
	const blob = new Blob([JSON.stringify(obj, null, 4)], { type: 'application/json' });
	const href = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = href;
	link.download = `${fileName}.json`;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(href);
};
